import "../../styles/salaryPayoutMode.css";

export const PAYOUT_WITH_DEDUCTIONS = "with_deductions";
export const PAYOUT_FULL_PAY = "full_pay";

export function normalizeSalaryPayoutMode(value) {
  const raw = String(value || "").trim().toLowerCase().replace(/[\s-]+/g, "_");
  if (["full_pay", "without_deductions", "no_deduction", "no_deductions", "none"].includes(raw)) {
    return PAYOUT_FULL_PAY;
  }
  return PAYOUT_WITH_DEDUCTIONS;
}

export function FullPayNotice() {
  return (
    <div className="spm-notice">
      This organisation pays the full salary. Deduction lines are not applied or shown.
      A salary of ₹15,000 is paid as ₹15,000. Overtime and leave encashment are still added.
    </div>
  );
}

export default function SalaryPayoutModeField({ value, onChange, disabled = false }) {
  const mode = normalizeSalaryPayoutMode(value);
  const pick = (next) => {
    if (!disabled) onChange(next);
  };

  return (
    <div className="spm-wrap">
      <span className="spm-label">Salary payout</span>
      <p className="spm-hint">
        Choose this for the whole organisation. Other organisations keep their own choice.
        Overtime and leave encashment stay the same either way.
      </p>
      <div className="spm-grid" role="radiogroup" aria-label="Salary payout">
        <button
          type="button"
          className={`spm-card${mode === PAYOUT_WITH_DEDUCTIONS ? " is-on" : ""}`}
          role="radio"
          aria-checked={mode === PAYOUT_WITH_DEDUCTIONS}
          disabled={disabled}
          onClick={() => pick(PAYOUT_WITH_DEDUCTIONS)}
        >
          <span className="spm-radio" aria-hidden="true" />
          <span>
            <span className="spm-card-title">With deductions</span>
            <span className="spm-card-copy">
              Use the salary structure as it is. Earnings and deductions such as PF, ESI,
              and professional tax are calculated and shown.
            </span>
          </span>
        </button>
        <button
          type="button"
          className={`spm-card${mode === PAYOUT_FULL_PAY ? " is-on" : ""}`}
          role="radio"
          aria-checked={mode === PAYOUT_FULL_PAY}
          disabled={disabled}
          onClick={() => pick(PAYOUT_FULL_PAY)}
        >
          <span className="spm-radio" aria-hidden="true" />
          <span>
            <span className="spm-card-title">Full salary, no deductions</span>
            <span className="spm-card-copy">
              Pay the full earnings amount. Deduction components are not applied and are
              not shown on the employee salary screen or the payslip.
            </span>
          </span>
        </button>
      </div>
      {mode === PAYOUT_FULL_PAY ? (
        <div className="spm-example">
          Example: monthly salary <strong>₹15,000</strong> is paid as <strong>₹15,000</strong>.
          No deduction line is shown. Approved overtime and leave encashment are still added on top.
        </div>
      ) : null}
    </div>
  );
}
